"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.metrics = void 0;
const shared_dto_1 = require("./dto/shared.dto");
if (typeof Buffer === 'undefined')
    global.Buffer = require('buffer').Buffer;
const DEFAULT_METRICS_URL = 'https://affinity-metrics.dev.affinity-project.org';
let fetch;
if (!fetch) {
    fetch = require('node-fetch');
}
const keccak256 = require('keccak256');
class Metrics {
    _linksDescriptionByEventName(eventName) {
        switch (eventName) {
            case shared_dto_1.EventName.USER_ONBOARDED:
                return { linkDescription: 'apiKey' };
            case shared_dto_1.EventName.VC_VERIFIED:
                return { linkDescription: 'holderDid' };
            case shared_dto_1.EventName.VC_VERIFIED_PER_PARTY:
                return { linkDescription: 'verifierDid', secondaryLinkDescription: 'vcId' };
            case shared_dto_1.EventName.VP_VERIFIED:
            case shared_dto_1.EventName.VP_VERIFIED_JWT:
                return { linkDescription: 'holderDid' };
            case shared_dto_1.EventName.VC_SAVED:
                return { linkDescription: 'vcId', secondaryLinkDescription: 'issuerId' };
            case shared_dto_1.EventName.VC_SIGNED:
                return { linkDescription: 'holderDid', secondaryLinkDescription: 'VcId' };
            case shared_dto_1.EventName.VP_SIGNED:
            case shared_dto_1.EventName.VP_SIGNED_JWT:
                return { linkDescription: 'holderDid', secondaryLinkDescription: 'VpId' };
            case shared_dto_1.EventName.VC_REVOKED:
                return { linkDescription: 'issuerDid' };
            case shared_dto_1.EventName.DID_CREATED:
            case shared_dto_1.EventName.DID_UPDATED:
                return { linkDescription: 'did' };
            default:
                // a safe guard
                return { linkDescription: 'not implemented' };
        }
    }
    _prepareEventParams(event) {
        // TODO: To check event's `link` and `secondaryLink` values if those are and should be DIDs
        // const regexDID = /^did:[\w|\d]{2,}:[\w|\d|:|;|\-|=]{10,}/
        const { link } = event;
        const linkBuffer = Buffer.from(link);
        const hashedLinkBuffer = keccak256(linkBuffer);
        const { name } = event;
        const { linkDescription, secondaryLinkDescription } = this._linksDescriptionByEventName(name);
        return Object.assign({}, event, Object.assign({ link: hashedLinkBuffer.toString('hex'), linkDescription }, (secondaryLinkDescription ? { secondaryLinkDescription } : {})));
    }
    send(eventInput, apiKeyHash, metricsUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const event = this._prepareEventParams(eventInput);
                metricsUrl = metricsUrl || DEFAULT_METRICS_URL;
                const url = `${metricsUrl}/api/v1/events/createEvent`;
                const body = JSON.stringify(event, null, 2);
                const headers = {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Api-Key': apiKeyHash
                };
                const response = yield fetch(url, { method: 'POST', headers, body });
                const result = yield response.json();
                if (response.status.toString().startsWith('2')) {
                    return result;
                }
                else {
                    throw new Error(result);
                }
            }
            catch (error) {
                //TODO: error handler and reporter
                return { error };
            }
        });
    }
}
exports.metrics = new Metrics();
//# sourceMappingURL=metrics.js.map